import { IObjectTypeState } from '../../types/redux/objectType';
import { TReduxActions } from '../../types/redux/actions';
import { EObjectTypeActions } from '../../constants/actionTypes/objectType';

export const defaultState = {
  value: null,
};

export function objectTypeReducer(state: IObjectTypeState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EObjectTypeActions.setObjectType:
      return {
        ...state,
        value: action.payload,
      };

    default:
      return state;
  }
}
